<template>
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      :modal-append-to-body="false"
      style="margin-top:1vh;"
      width="480px"
      :close-on-click-modal="false"
    >
      <div slot="title" class="title">统计说明</div>
      <div class="tip-container">
        <div class="tip-li" v-for="(item,index) in content" :key="index">
          <div class="li-title">{{ item.title }} <span class="li-other" v-if="item.other">({{item.other}})</span></div>
          <div class="li-content" v-for="(liItem,liIndex) in item.list" :key="liIndex">
            <div class="content-detail-li">
              <span class="detail-li-title">{{ liItem.title }}:</span>{{liItem.detail}}
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary"   @click="dialogVisible=false" >我知道了</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'tipDialog',
  data() {
    return {
      dialogVisible: false,
      content: [],
      content1: [
        {
          title: '一、近期波动',
          other: '',
          list: [
            {
              title: '1、发起申请数',
              detail: '成员主动向客户发起的好友申请数量'
            },
            {
              title: '2、新增客户数',
              detail: '成员新添加客户数量，基于关系链统计，例如3个成员添加同一客户，则新增客户数计为3'
            },
            {
              title: '3、新绑档案数',
              detail: '客莱宝侧边栏成功绑定新客户档案数量'
            },
            {
              title: '4、删除/拉黑数',
              detail: '将成员删除或加入黑名单的客户数量。'
            },
            {
              title: '5、新增群聊数',
              detail: '统计时间内，全部员工新增的外部群聊数，去重'
            },
            {
              title: '6、活跃群成员数',
              detail: '统计时间内， 有发消息的成员数'
            },
            {
              title: '7、群聊消息数',
              detail: '统计时间内，所有外部群聊的消息总数'
            },
            {
              title: '8、群日均消息数',
              detail: '统计时间内，所有外部群聊的消息总数除以统计天数的平均值。'
            },
            {
              title: '9、群聊总人数',
              detail: '统计时间内，所有外部群聊人数总和，不去重'
            },
            {
              title: '10、进/退群人数',
              detail: '统计时间内，所有外部群聊进/退群人数总和'
            },
          ]
        },
        {
          title: '二、历史累计',
          other: '数据统计不随统计周期修改而变化',
          list: [
            {
              title: '1、绑定客户数',
              detail: '现有已绑定档案客户人数'
            },
            {
              title: '2、绑定档案数',
              detail: '新增客户数：现有所有已绑定客户绑定档案总数'
            },
            {
              title: '3、群聊总数',
              detail: '指截止今天的群聊总数，会变化，但不会随统计区间变化'
            }
          ]
        },
      ],
      content2: [
        {
          title: '客户联系',
          other:'',
          list: [
            {
              title: '1、聊天总数',
              detail: '成员有主动发送过消息的单聊总数。'
            },
            {
              title: '2、发送消息数',
              detail: '成员在单聊中发送的消息数量'
            },
            {
              title: '3、平均首次回复时长',
              detail:`一个自然日内，客户首先发消息至成员回复之间的时长，为首次回复时长；所有首次回复的总时长/已回复单聊总数，为单日的平均首次回复时长。\n若统计跨度为多个自然日 ，平均首次回复时长即为多个单日的平均首次回复时长的日平均值。若数据展示为“-”代表没有给成员发送消息的客户，该项无法计算。`

            }
          ]
        },
      ]
    }
  },
  methods: {
    // val:1展示content1,2展示content2
    show(val) {
      this.content = val==1?this.content1:this.content2;
      this.dialogVisible = true;
    },

  }
}
</script>

<style lang="scss" scoped>
.title {
  font-weight: bold;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.9);
}
.tip-container {
  font-size: 14px;
  line-height: 22px;
  .tip-li {
    margin-bottom: 16px;
    .li-title {
      font-weight: bold;
      font-size: 14px;
      margin-bottom: 12px;
      border-bottom: 1px solid #EEEFF3;
      color: rgba(0, 0, 0, 0.9);
      .li-other {
        color: rgba(0, 0, 0, 0.6);
      }
    }
    .li-content {
      font-size: 12px;
      font-weight: 400;
      .content-detail-li {
        white-space: pre-wrap;
        .detail-li-title {
          color: rgba(0, 0, 0, 0.9);
          font-weight: 500;
          margin-right: 8px;
        }
      }
    }
    &:last-of-type {
      margin-bottom: 0;
    }
  }
  
}
.dialog-footer {
  /deep/.el-dialog__headerbtn:focus .el-dialog__close, .el-dialog__headerbtn:hover .el-dialog__close {
    color: rgba(0, 0, 0, 0.6);
    background-color: #E6E6E6;
  }
  /deep/ .el-button {
    line-height: unset;
    padding: 5px 16px;
  }
}
/deep/ .el-dialog__header {
  padding: 28px 28px 10px 32px;
}
/deep/ .el-dialog__body {
  padding: 0 32px;
}
/deep/ .el-dialog__footer {
  padding: 24px 32px 32px;
}
</style>